import React, { useEffect, useState , useContext, useRef} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { studentProfile,
   studentCourses,
   membderShip, loginOtp, syncSalesForce, generateReferral, 
   getMemberShip, courseLevel,freeAttempt,
     extendExpriey, extendOfflineEnrollmentExpiry, resetotp, numberOfClassesExpiry,freeAttemptCount, 
     getGraded, checkPolicy, changePolicy, addStduentOffline, getOfflineTeachers, getAddOfflineStudent, updateIs30MinsClass, reactivateStudent } from "../../../../../Api/apiUtils";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Image } from "../../../../../AbstractElements";
import { Badge, Button, DescriptionList, Field, Loader, Select, TextInput } from "../../../../../ui";
import { Actions, Callout, Dialog, StudentStatusBadge, TextArea } from "../ui-pending";
import "./style.scss";
import ProfileForm from "../profileForm";
import { IoShareSocial } from "react-icons/io5";
import { LiaSalesforce } from "react-icons/lia";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { MdInstallMobile } from "react-icons/md";
import { FaCopy } from 'react-icons/fa';
import { toast } from "react-toastify";
import { certifications } from "./certication";
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';
import { ConfigContext} from "../../../../../Api/global/ApiContext"
import { isTeacherLeaderDisabled } from "../../../../../utils/permissions";
import ClickToCall from "../../../../../Telephony/ClickToCall";
import { openDashboardWithAuth } from "../../../../../utils/dashboardHandoff";



interface CourseData {
  courseName: string;
  courseId: any;
  teacherName: string;
  unscheduledClasses: any;
  remainingClasses: any;
  totalClasses: any;
  completedClasses:any;
  teacherUserId: any;
  selectedCourseData:any
  level_name:any;
}

interface HomeProps {
  studentId: string;
  credentialId: string;
  activeTab: string;
  selectedCourseDetails:any;
  selectedCourseData:any;
  selectedCourse:any;
  fetchCourses: () => Promise<void>;
  courseCounts: {
    unscheduledClasses: number;
    completedClasses: number;
    scheduledClasses: number;

  };
}

interface Certification {
  courseParentTagId?: number[];
  courses?: number[];
  certification?: string[];
  gradeLevel?: string[];
}

type OfflineExpiryReasonOption = {
  value: string;
  label: string;
  description: string;
  maxExtensionDays?: number;
};

const OFFLINE_EXPIRY_REASON_OPTIONS: OfflineExpiryReasonOption[] = [
  {
    value: "medical_reasons",
    label: "Medical Reasons",
    description:
      "Valid medical documentation must be shared. Intimation should be made as early as reasonably possible. Extension: up to 30 days.",
    maxExtensionDays: 30,
  },
  {
    value: "bereavement",
    label: "Bereavement",
    description:
      "Applicable in case of a death in the immediate family. Extension: up to 20 days.",
    maxExtensionDays: 20,
  },
  {
    value: "classes_missed_due_to_artium",
    label: "Classes Missed Due to Artium",
    description:
      "Includes classes cancelled by Artium for internal training, maintenance, natural calamities, unfavourable learning conditions, or teacher unavailability. These classes will be rescheduled first; if they cannot be completed within the membership period, an extension will be granted.",
  },
  {
    value: "temporary_short_term_availability_constraints",
    label: "Temporary Short-term Availability Constraints",
    description:
      "Includes parent-related constraints for learners below 15 and work-related travel for adult learners above 21. Learners should first try rescheduling or attending more than 2 classes per week. If completion is still not possible, extension may be granted up to 10 days; further extension only in exceptional cases.",
    maxExtensionDays: 10,
  },
  {
    value: "school_exams",
    label: "School Exams",
    description:
      "The official exam schedule must be shared via email. Regular exams: up to 15 days. Board Exams (10th & 12th) and competitive exams for adults: up to 60 days.",
    maxExtensionDays: 60,
  },
];

const addDays = (date: Date, days: number): Date => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
};

// Add this new component before the Home component
const PolicyChangeModalContent = React.memo(({ 
  onClose, 
  onConfirm, 
  isLoading 
}: { 
  onClose: () => void; 
  onConfirm: (reason: string) => void; 
  isLoading: boolean;
}) => {
  const [reason, setReason] = useState('');
  const config = useContext(ConfigContext);
  const {  offlineCentres    =[] , grmpcourses = []} = config || {};
  const handleConfirm = () => {
    if (!reason.trim()) {
      toast.error("Please provide a reason for the policy change");
      return;
    }
    onConfirm(reason);
  };

  return (
    <>
      <Field label="Reason for policy change" id="policyChangeReason" required>
        {(ctl) => (
          <TextArea
            {...ctl}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for changing policy"
            required
          />
        )}
      </Field>
      <Actions>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={!reason.trim()}
          loading={isLoading}
        >
          {isLoading ? "Changing..." : "Confirm Change"}
        </Button>
      </Actions>
    </>
  );
});

const Home: React.FC<HomeProps> = ({ studentId, credentialId, courseCounts, selectedCourseData, selectedCourse, fetchCourses, selectedCourseDetails }) => {
  console.log("selectedCourseData",selectedCourseDetails)
  const readOnly = isTeacherLeaderDisabled();
  const navigate = useNavigate();

const matchedCourse = selectedCourseData?.find((course:any) => course.courseId === selectedCourse);

// Check if navigation came from offline students page
const location = useLocation();
const isFromOfflinePage = new URLSearchParams(location.search).get('student') === 'offline';

// Get offline centres and courses from config context
const config = useContext(ConfigContext);
const { offlineCentres = [], grmpcourses = [] } = config || {};

const formatExpiryDate = (dateString: string | undefined): string => {
  if (!dateString) return "No expiry date available";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "No expiry date available";

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  };

  return date.toLocaleString("en-US", options).replace(",", "");
};
  const [attemptValue, setAttemptValue] = useState("");
  const [attemptCount, setAttemptCount] = useState<number>(0); 
  const [studentData, setStudentData] = useState<any>(null);
  const [courseslevel, setCoursesLevel] = useState("");
  const [otp, setOtp] = useState<string>("");
  const [otpLoading, setOtpLoading] = useState(false);
  const otpRequestInFlight = useRef(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modal, setModal] = useState(false); 
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const [shortUrl, setShortUrl] = useState<string | null>(null);
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);
  const [expiryCount, setExpiryCount] = useState<Date | null>(null);
    const [modificationReason, setModificationReason] = useState(''); 
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [certificate, setCertificate] = useState(""); 
    const [certificateOptions, setCertificateOptions] = useState<string[]>([]);
    const [selectedCertificate, setSelectedCertificate] = useState< string | null>(null);
    const [currentCertificate, setCurrentCertificate] = useState<string>("");
    const [loadingSalesForce, setLoadingSalesForce] = useState(false);
    
    const [pendingMembershipChange, setPendingMembershipChange] = useState({

      membershipType: ''
    });
  const [selectedTeacher, setSelectedTeacher] = useState<string>("");
  const [selectedMembership, setSelectedMembership] = useState<string>(studentData?.membershipType || '');
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);

  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const [showResetModal, setShowResetModal] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const [policyEnabled, setPolicyEnabled] = useState<boolean>(false);
  const [policyLoading, setPolicyLoading] = useState<boolean>(false);

  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [policyChangeReason, setPolicyChangeReason] = useState('');

  const [is30MinsClass, setIs30MinsClass] = useState<boolean>(false);
  const [is30MinsClassLoading, setIs30MinsClassLoading] = useState<boolean>(false);
  const [show30MinsClassModal, setShow30MinsClassModal] = useState<boolean>(false);
  const [pending30MinsClassChange, setPending30MinsClassChange] = useState<boolean | null>(null);
  const [thirtyMinsChangeReason, setThirtyMinsChangeReason] = useState("");

  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [studentStatusLoading, setStudentStatusLoading] = useState(false);

  // Offline Course Modal States
  const [showOfflineCourseModal, setShowOfflineCourseModal] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState<any>(null);
  const [selectedOfflineCourse, setSelectedOfflineCourse] = useState<any>(null);
  const [selectedOfflineTeacher, setSelectedOfflineTeacher] = useState<any>(null);
  const [offlineTeachers, setOfflineTeachers] = useState<any[]>([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  const [offlineEnrollmentLoading, setOfflineEnrollmentLoading] = useState(false);
  const [offlineMonthsPurchased, setOfflineMonthsPurchased] = useState<string>("");
  const [offlineStartDate, setOfflineStartDate] = useState<Date | null>(null);
  const [offlineSelectedLevel, setOfflineSelectedLevel] = useState<string>("");
  const isOfflineBatchCourse =
    selectedCourseDetails?.batchOfflineCourse === true &&
    selectedCourseDetails?.isDemoCourse === false;
  const selectedOfflineReason = OFFLINE_EXPIRY_REASON_OPTIONS.find(
    (option) => option.value === modificationReason
  );
  const currentCourseExpiryDate = matchedCourse?.expiryDate
    ? new Date(matchedCourse.expiryDate)
    : null;
  const offlineExpiryMaxDate =
    isOfflineBatchCourse &&
    currentCourseExpiryDate &&
    !Number.isNaN(currentCourseExpiryDate.getTime()) &&
    selectedOfflineReason?.maxExtensionDays
      ? addDays(currentCourseExpiryDate, selectedOfflineReason.maxExtensionDays)
      : undefined;
  const [pendingPolicyChange, setPendingPolicyChange] = useState<boolean | null>(null);
  const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");


  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      setModificationReason('');
      setExpiryDate(null);
    }
  };

  useEffect(() => {
    if (selectedCourse && studentId) {
      getGradedCertificate();
      if (!selectedCourseDetails?.isDemoCourse) {
        getAttemptCount();
        checkPolicyStatus();
      }
      fetchMembership();
      upcomingExpiry();
      setSelectedCertificate('');
      setSelectedMembership('');
    }
  }, [selectedCourse, studentId, selectedCourseDetails?.isDemoCourse]);

  useEffect(() => {
    if (selectedCourseDetails?.courseEnrollmentId !== undefined) {
      setIs30MinsClass(selectedCourseDetails?.is30MinsClass || false);
    }
  }, [selectedCourseDetails]);
  useEffect(() => {

    fetchStudentProfile();
  }, [studentId]);

  const fetchStudentProfile = async () => {
    try {
      const data = await studentProfile(credentialId, studentId);
      setStudentData(data);
console.log("Student Data:", data); // Debugging
      if (data?.userId) {
        localStorage.setItem("studentUserId", data.userId);
      }

 
    } catch (error) {
      console.error("Error fetching student profile:", error);
    }
  };

  const fetchOtp = async () => {
    setShortUrl("");
    try {
      const response = await loginOtp(credentialId);
      console.log("OTP Response:", response);
      setOtp(response.data?.OTP);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching OTP:", error);
    } finally {
      otpRequestInFlight.current = false;
      setOtpLoading(false);
    }
  };
  
  const handleSubmit = async () => {
    if (!expiryDate || !modificationReason) {
      toast.error('Please select expiry date and reason.');
      return;
    }

    const formattedDate = `${expiryDate.getFullYear()}-${(expiryDate.getMonth()+1).toString().padStart(2, '0')}-${expiryDate.getDate().toString().padStart(2, '0')}`;
    const reasonValue = isOfflineBatchCourse
      ? selectedOfflineReason?.label || modificationReason
      : modificationReason;

    setIsSubmitting(true);
    try {
      trackEvent(MixpanelEvents.EXTEND_EXPIRY, {
        page: "Student Profile Extend Expiry",
        studenId: studentId,
        courseId: selectedCourse,
        expiryDate: isOfflineBatchCourse ? formattedDate : `${formattedDate} 00:00:00`,
        modificationReason: reasonValue,
        batchOfflineCourse: isOfflineBatchCourse,
      });

      if (isOfflineBatchCourse) {
        const enrollmentId = selectedCourseDetails?.courseEnrollmentId;
        if (!enrollmentId) {
          toast.error('Enrollment ID not found for this offline course.');
          return;
        }

        await extendOfflineEnrollmentExpiry(enrollmentId, {
          newExpiryDate: formattedDate,
          reason: reasonValue,
        });
      } else {
        await extendExpriey({
          studentId,
          courseId: selectedCourse,
          expiryDate: `${formattedDate} 00:00:00`,
          modificationReason: reasonValue,
        });
      }

      fetchCourses();
      toast.success('Expiry date extended successfully!');
      toggleModal();
      setModificationReason('');
      setExpiryDate(null);
    } catch (error: any) {
      console.error('Error extending expiry date:', error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      toast.error(apiMessage || 'Failed to extend expiry date. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };


  useEffect(() => {
    if (selectedCourse) {
      getCertificateOptions();
      getGradedCertificate(); // Fetch current certificate
    }
  }, [selectedCourse]);
    const upcomingExpiry = async () => {
  
      const courseId = selectedCourse;
      if (selectedCourseDetails?.isDemoCourse === false) {
      try {
        const data = await numberOfClassesExpiry(studentId, courseId);
        const reponse = data.numberOfClassesUpcomingExpiry;
        setExpiryCount(reponse);
        console.log("s")
        console.log("Student Data:", data); // Debugging
        
        if (data?.userId) {
          localStorage.setItem("studentUserId", data.userId);
        }
      } catch (error) {
        console.error("Error fetching student profile:", error);
      }
    }

    };
    const getCertificateOptions = () => {
      console.log("Selected Course:", selectedCourse, "Type:", typeof selectedCourse);
  
    
      const courseCertification = certifications.find((cert) => {
        const courseList = cert.courses || cert.courseId || [];
    
        const normalizedCourseList = courseList.map((id) => Number(id));
        const selectedCourseId = Number(selectedCourse);
    
        return normalizedCourseList.includes(selectedCourseId);
      });
    
      console.log("Found certification:", courseCertification);
    
      if (courseCertification?.certification) {
        setCertificateOptions(courseCertification.certification);
        console.log("All certifications:", certificateOptions);
        // if (!selectedCertificate && courseCertification.certification.length > 0) {
        //   setSelectedCertificate(courseCertification.certification[0]);
        // }
    
      } else {
        setCertificateOptions([]);
        setSelectedCertificate("");
      }
    };


const handleSyncSalesForce = async () => {
  setLoadingSalesForce(true);
  const studentId = studentData.studentId; 
  
  if (!studentId) {
    toast.error("Student ID is missing.");
    return;
  }
try {
      console.log("Sync Salesforce button clicked");
      const response = await syncSalesForce(studentId); 
      console.log("Sync successful:", response);
  
      if (response.data) {
        toast.success('Salesforce sync successful!');
      } else {
        toast.error('Failed to sync Salesforce. Please try again.');
      }
      setLoadingSalesForce(false);
  } catch (error) {
    setLoadingSalesForce(false);
    toast.error("Error updating free attempt");
  }
};

  // Filter offline courses from grmpcourses
  const getOfflineCourses = () => {
    if (!grmpcourses || grmpcourses.length === 0) return [];
    return grmpcourses.filter((course: any) => 
      course.name && course.name.toLowerCase().includes('offline')
    );
  };

  // Fetch offline teachers when course is selected
  const fetchOfflineTeachers = async (courseV2Id: string) => {
    setLoadingTeachers(true);
    setOfflineTeachers([]);
    const payload ={
      courseId: courseV2Id, page: 0, size: 500
    }
    try {
      const response = await getOfflineTeachers(payload);
      console.log('Offline teachers response:', response);
      
      if (response && response.data && response.data.content && Array.isArray(response.data.content)) {
        setOfflineTeachers(response.data.content);
      } else {
        setOfflineTeachers([]);
        toast.info('No teachers available for this course');
      }
    } catch (error) {
      console.error('Error fetching offline teachers:', error);
      setOfflineTeachers([]);
      toast.error('Failed to fetch teachers');
    } finally {
      setLoadingTeachers(false);
    }
  };

  // Handle Offline Course Modal
  const handleOfflineCourse = () => {
    setShowOfflineCourseModal(true);
    setSelectedCenter(null);
    setSelectedOfflineCourse(null);
    setSelectedOfflineTeacher(null);
    setOfflineTeachers([]);
    setOfflineMonthsPurchased("");
    setOfflineStartDate(null);
    setOfflineSelectedLevel("");
  };

  // Handle Offline Course Enrollment Submit
  const handleOfflineCourseSubmit = async () => {
    if (!selectedCenter) {
      toast.error("Please select a center");
      return;
    }

    if (!selectedOfflineCourse) {
      toast.error("Please select a course");
      return;
    }

    if (!selectedOfflineTeacher) {
      toast.error("Please select a teacher");
      return;
    }

    setOfflineEnrollmentLoading(true);

    try {
      const payload: any = {
        studentId: studentData.studentId,
        courseId: selectedOfflineCourse.v2Id,
        teacherId: selectedOfflineTeacher.teacherId,
        offlineCentreId: selectedCenter.centerId,
        classesPerMonth: 8, // Hardcoded as per requirement
      };

      // Add monthsPurchased if provided
      if (offlineMonthsPurchased) {
        payload.monthsPurchased = parseInt(offlineMonthsPurchased);
      }

      // Add startDate if provided
      if (offlineStartDate) {
        payload.startDate = `${offlineStartDate.getFullYear()}-${(offlineStartDate.getMonth()+1).toString().padStart(2, '0')}-${offlineStartDate.getDate().toString().padStart(2, '0')}`;
      }

      // Add level - default to PREPARATORY if not selected
      payload.level = (offlineSelectedLevel || "PREPARATORY").toUpperCase();

      console.log("Offline enrollment payload:", payload);

      const response = await getAddOfflineStudent(payload);
      console.log("Offline enrollment response:", response);

      toast.success(`Successfully enrolled in ${selectedOfflineCourse.name} at ${selectedCenter.centreName}`);
      
      // Track Mixpanel event
      trackEvent(MixpanelEvents.OFFLINE_COURSE_ENROLLMENT, {
        studentId: studentData.studentId,
        centerId: selectedCenter.centerId,
        centerName: selectedCenter.centreName,
        courseId: selectedOfflineCourse.v2Id,
        courseName: selectedOfflineCourse.name,
        teacherId: selectedOfflineTeacher.teacherId,
        teacherName: selectedOfflineTeacher.teacherName,
        enrolledAt: new Date().toISOString()
      });

      // Close modal and reset
      setShowOfflineCourseModal(false);
      setSelectedCenter(null);
      setSelectedOfflineCourse(null);
      setSelectedOfflineTeacher(null);
      setOfflineTeachers([]);
      setOfflineMonthsPurchased("");
      setOfflineStartDate(null);
      setOfflineSelectedLevel("");
      
    } catch (error: any) {
      console.error("Error enrolling in offline course:", error);
      
      // Check if error has status 400 and show the API message
      if (error?.response?.status === 400 && error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error?.status === 400 && error?.message) {
        toast.error(error.message);
      } else {
        toast.error("Failed to enroll in offline course. Please try again.");
      }
    } finally {
      setOfflineEnrollmentLoading(false);
    }
  };






  

  


  const handleFreeAttempt = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const penaltyAttemptUtilized = Number(e.target.value); // Get the selected value
    
    const payload = {
      studentId: studentData.studentId,
      courseId: selectedCourse,
      penaltyAttemptUtilized,
    };
  


    try {
      console.log("Updated Payload:", payload);
      await freeAttempt(payload);
      setAttemptCount(penaltyAttemptUtilized);
      getAttemptCount();
      toast.success("Free Attempt Updated Successfully");
    } catch (error) {
      toast.error("Error updating free attempt");
    

  }
  };
  
  
  

  const handleMembershipSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMembershipType = e.target.value;
    setPendingMembershipChange({ membershipType: newMembershipType });
    setShowConfirmationModal(true);
  };

  const fetchMembership = async () => {  
    const courseId = selectedCourse;
    
 

    if (selectedCourseDetails?.isDemoCourse === false) {
    try {
      const response = await getMemberShip(studentId, courseId);
      console.log("Membership response:", response); // Debug log
      
      // Update based on response
      if (response?.membershipType) {
        setSelectedMembership(response.membershipType);
      } else {
        setSelectedMembership('N/A'); // Default value if no membership
      }
    } catch (error) {
      console.error("Error fetching membership:", error);
      setSelectedMembership('N/A'); // Default value on error
    }
    }
  };


  const getAttemptCount = async () => { 
    if (selectedCourseDetails?.isDemoCourse) {
      return;
    }

    const courseId = selectedCourse;
  
    try {
      const response = await freeAttemptCount(studentId, courseId);
      const data = response.numberOfFreePenalty;
      setAttemptCount(data);
    } catch (error) {
      console.error("Error fetching attempt count:", error);
      // You might want to set some default value or show an error toast
    }

  };


  
  const getGradedCertificate = async () => { 
    try {
      const response = await getGraded(
        studentId, 
        selectedCourse, 
        "getCertification" // Special value to get current certificate
      );
      setCurrentCertificate(response.gradedCertification);
      // Pre-select the current certificate in dropdown
      if (response.gradedCertification) {
        setSelectedCertificate(response.gradedCertification || "");
      }
    } catch (error) {
      console.error("Error fetching certificate:", error);
      // toast.error("Failed to fetch certificate");
    }
  };
  
  // const gradedCertificate = async () => { 
  //   if (!selectedCertificate) return; // Don't send if nothing selected
    
  //   try {
  //     const response = await getGraded(
  //       studentId, 
  //       selectedCourse, 
  //       selectedCertificate // Send the actual selected value
  //     );
  //     // Update current certificate after successful change
  //     setCurrentCertificate(response.gradedCertification);
  //     toast.success("Certificate updated successfully");
  //   } catch (error) {
  //     console.error("Error updating certificate:", error);
  //     toast.error("Failed to update certificate");
  //   }
  // };
  
  const handleCertificateChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const cert = e.target.value;
    console.log("Selected value:", cert); // Debug what's actually being selected
    setSelectedCertificate(cert);
    
    if (cert) {
      try {
        const response = await getGraded(
          studentId,
          selectedCourse,
          cert // Send the exact selected value
        );
        setCertificate(response.gradedCertification);
        toast.success("Certificate updated successfully");
      } catch (error) {
        console.error("Update failed:", error);
        toast.error("Failed to update certificate");
      }
    }
  };
  

  const confirmMembershipChange = async () => {
    if (!pendingMembershipChange.membershipType) return;
    
    setLoading(true);
    try {
      const response = await membderShip(
        studentId, 
        selectedCourse, 
        pendingMembershipChange.membershipType
      );
      trackEvent(MixpanelEvents.MEMBERSHIP_UPDATE, {
        page:"Student Profile Membership update",
        "studentId":studentId, 
       "courseId":selectedCourse, 
      "memberShip": pendingMembershipChange.membershipType,
 
            });
      console.log("Membership updated successfully:", response);
      toast.success("Membership updated successfully!");
      fetchMembership(); // Refresh data
      
    } catch (error) {
      console.error("Error updating membership:", error);
      toast.error("Failed to update membership. Please try again.");
    } finally {
      setLoading(false);
      setShowConfirmationModal(false);
    }
  };
  useEffect(() => {
    const fetchCourseLevel = async () => {
      const userId = studentData?.userId;
      const courseId = selectedCourse;
      if (!userId || !courseId) {
        return;
      }

      try {
          const response = await courseLevel(userId, courseId);
          const levelName = response?.status?.[0]?.level_name;
          if (levelName) {
            setCoursesLevel(levelName);
          }
          console.log("Course level data:", response);
  
      } catch (error) {
          console.error("Failed to fetch course level:", error);
   
      }
  
  };
  fetchCourseLevel()
  }, [studentData?.userId, selectedCourse]);
  

  const cancelMembershipChange = () => {
    setShowConfirmationModal(false);
    // Reset the select to the current membership type
    setSelectedMembership(studentData?.membershipType || '');
  };

  const handleGenerateReferral = async () => {
    const loginUser = localStorage.getItem("loginUser");
 
    setIsModalOpen(true);
    try {
      const data = {
        utmSource: loginUser,
        userId: studentData.userId,
        role: studentData.role,
        name: studentData.firstName,
        mobileNumber: studentData.mobileNumber,
        countryCode: studentData.countryCode,
        ageGroup: studentData.ageGroup,
        gender: studentData.gender,
        courseName: selectedCourse || "",
        state: studentData.state || "",
        clickType: "admin",
        studentType: studentData.studentType,
      };

      console.log("Payload:", JSON.stringify(data, null, 2));

      // Call API from API utils
      const response = await generateReferral(data);

      // Set short URL from API response
      setShortUrl(response.shortUrl);

      toast.success("Link Generated Successfully");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed. Please try again.");
    }
  };


  const checkPolicyStatus = async () => {
    if (selectedCourseDetails?.isDemoCourse) {
      return;
    }

    try {
      const response = await checkPolicy(studentId, selectedCourse);
      setPolicyEnabled(response);
    } catch (error) {
      console.error("Error checking policy status:", error);
    }
  };
  

  const handlePolicyToggle = () => {
    const newStatus = !policyEnabled;
    setPendingPolicyChange(newStatus);
    setShowPolicyModal(true);
  };

  const confirmPolicyChange = async (reason: string) => {
    console.log("Reason received in confirmPolicyChange:", reason);
    setPolicyLoading(true);
    try {
      const payload = {
        studentId,
        courseId: selectedCourse,
        policy: pendingPolicyChange ? "new" : "old"
      };

      trackEvent(MixpanelEvents.POLICY_CHANGE, {
        page: "Student Profile Policy Change Toggle",
        studenId: studentId,
        courseId: selectedCourse,
        policy: pendingPolicyChange ? "new" : "old",
        reason: reason
      });

      await changePolicy(payload);
      setPolicyEnabled(pendingPolicyChange!);
      toast.success(`Policy changed to ${pendingPolicyChange ? 'new' : 'old'} policy successfully`);
      checkPolicyStatus();
    } catch (error) {
      console.error("Error toggling policy:", error);
      toast.error("Failed to update policy status");
    } finally {
      setPolicyLoading(false);
      setShowPolicyModal(false);
      setPolicyChangeReason('');
      setPendingPolicyChange(null);
    }
  };

  const handleReset = () => {
    // Implement reset logic here
  };

  const handleIs30MinsClassToggle = () => {
    const studentUserId = studentData?.userId;
    const courseId = selectedCourse;
    if (!studentUserId || !courseId) {
      toast.error("Student or course information is missing");
      return;
    }

    const newValue = !is30MinsClass;
    setPending30MinsClassChange(newValue);
    setThirtyMinsChangeReason("");
    setShow30MinsClassModal(true);
  };

  const confirm30MinsClassChange = async () => {
    const studentUserId = studentData?.userId;
    const courseId = selectedCourse;
    if (!studentUserId || !courseId || pending30MinsClassChange === null) {
      return;
    }
    if (!thirtyMinsChangeReason.trim()) {
      toast.error("Please provide a reason for the 30 min class change");
      return;
    }

    setIs30MinsClassLoading(true);

    try {
      const reason = thirtyMinsChangeReason.trim();
      await updateIs30MinsClass(studentUserId, courseId, pending30MinsClassChange, reason);
      setIs30MinsClass(pending30MinsClassChange);
      trackEvent(MixpanelEvents.THIRTY_MIN_CLASS_TOGGLE, {
        page: "Student Profile 30 Min Class Toggle",
        studentId,
        studentUserId,
        courseId,
        is30Mins: pending30MinsClassChange,
        action: pending30MinsClassChange ? "enabled" : "disabled",
        reason,
      });
      toast.success(`30 mins class ${pending30MinsClassChange ? 'enabled' : 'disabled'} successfully`);
      // Refresh course data
      if (fetchCourses) {
        await fetchCourses();
      }
    } catch (error) {
      console.error("Error toggling is30MinsClass:", error);
      toast.error("Failed to update 30 mins class status");
    } finally {
      setIs30MinsClassLoading(false);
      setShow30MinsClassModal(false);
      setPending30MinsClassChange(null);
      setThirtyMinsChangeReason("");
    }
  };

  const cancel30MinsClassChange = () => {
    setShow30MinsClassModal(false);
    setPending30MinsClassChange(null);
    setThirtyMinsChangeReason("");
  };

  const isStudentAccountActive = (() => {
    if (!studentData) return true;
    if (typeof studentData.enabled === "boolean") return studentData.enabled;
    if (typeof studentData.isActive === "boolean") return studentData.isActive;
    if (typeof studentData.active === "boolean") return studentData.active;
    const status = String(
      studentData.accountStatus ?? studentData.userStatus ?? studentData.status ?? ""
    ).toUpperCase();
    if (!status) return true;
    return !/(INACTIV|DEACTIV|DISABLED|DELETED|BLOCKED)/.test(status);
  })();

  const handleStudentActiveToggle = () => {
    if (readOnly || studentStatusLoading) return;
    if (isStudentAccountActive) {
      setShowDeactivateModal(true);
      return;
    }
    void confirmReactivateStudent();
  };

  const confirmDeactivateStudent = async () => {
    if (!studentId) {
      toast.error("Student ID is missing");
      return;
    }
    setStudentStatusLoading(true);
    try {
      await reactivateStudent(studentId);
      trackEvent(MixpanelEvents.STUDENT_PROFILE_UPDATE, {
        page: "Student Profile Deactivate",
        studentId,
        action: "deactivated",
      });
      toast.success("Student deactivated successfully");
      setShowDeactivateModal(false);
      navigate(`${process.env.PUBLIC_URL}/pages/student-profile`);
    } catch (error: any) {
      console.error("Error deactivating student:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to deactivate student"
      );
    } finally {
      setStudentStatusLoading(false);
    }
  };

  const confirmReactivateStudent = async () => {
    if (!studentId) {
      toast.error("Student ID is missing");
      return;
    }
    setStudentStatusLoading(true);
    try {
      await reactivateStudent(studentId);
      trackEvent(MixpanelEvents.STUDENT_PROFILE_UPDATE, {
        page: "Student Profile Reactivate",
        studentId,
        action: "reactivated",
      });
      toast.success("Student reactivated successfully");
      await fetchStudentProfile();
    } catch (error: any) {
      console.error("Error reactivating student:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to reactivate student"
      );
    } finally {
      setStudentStatusLoading(false);
    }
  };

  // Update the PolicyChangeModal component in the Home component
  const PolicyChangeModal = () => {
    const handleClose = () => {
      if (!policyLoading) {
        setShowPolicyModal(false);
        setPolicyChangeReason('');
        setPendingPolicyChange(null);
      }
    };

    const handleConfirm = (reason: string) => {
      console.log("Reason received in handleConfirm:", reason);
      setPolicyChangeReason(reason);
      confirmPolicyChange(reason);
    };

    return (
      <Dialog isOpen={showPolicyModal} onClose={handleClose} title="Confirm policy change">
        <PolicyChangeModalContent
          onClose={handleClose}
          onConfirm={handleConfirm}
          isLoading={policyLoading}
        />
      </Dialog>
    );
  };

  const readOnlyTitle = readOnly ? "Disabled for Teacher Leaders" : undefined;

  const detailItems = studentData
    ? [
        {
          label: "Phone",
          value: readOnly ? (
            <span className="student-home__masked" title="Hidden for Teacher Leaders">
              ••••••••••••
            </span>
          ) : (
            <ClickToCall
              number={studentData.mobileNumber ? `${studentData.countryCode || ""}${studentData.mobileNumber}` : undefined}
              name={`${studentData.firstName || ""} ${studentData.lastName || ""}`.trim()}
              sourceRecordId={studentId}
              customerUserId={studentData.userId ? String(studentData.userId) : undefined}
            />
          ),
        },
        {
          label: "Email",
          value: readOnly ? (
            <span className="student-home__masked" title="Hidden for Teacher Leaders">
              ••••@••••.com
            </span>
          ) : (
            studentData.emailId || "—"
          ),
        },
        ...(courseslevel ? [{ label: "Course level", value: <span className="ds-strong">{courseslevel}</span> }] : []),
        {
          label: "Certificate details",
          value: <span className="ds-strong">{selectedCertificate || "No Data"}</span>,
        },
      ]
    : [];

  return (
    <div className="student-home">
      <div className="student-home__summary">
        <Badge tone={studentData?.userType === "PAID" ? "success" : "warning"}>
          {studentData?.userType}
        </Badge>
        {studentData?.userType !== "DEMO" && (
          <span className="student-home__expiry">
            Expiry date: <span className="ds-strong">{formatExpiryDate(matchedCourse?.expiryDate)}</span>
          </span>
        )}
      </div>

      {studentData ? (
        <>
          <div className="student-home__actions" role="group" aria-label="Student quick actions">
            <Button
              size="sm"
              icon={<MdInstallMobile size={16} aria-hidden />}
              onClick={() => { if (readOnly) return; setShowResetModal(true); }}
              disabled={readOnly}
              title={readOnlyTitle}
            >
              Reset OTP
            </Button>
            <Button
              size="sm"
              icon={<MdInstallMobile size={16} aria-hidden />}
              onClick={() => {
                if (readOnly || otpLoading || otpRequestInFlight.current) return;
                otpRequestInFlight.current = true;
                setOtpLoading(true); // disable immediately on click
                void fetchOtp();
              }}
              loading={otpLoading}
              disabled={readOnly}
              title={readOnly ? "Disabled for Teacher Leaders" : otpLoading ? "Fetching OTP…" : undefined}
            >
              {otpLoading ? "Fetching…" : "Get OTP"}
            </Button>
            {!isFromOfflinePage && (
              <Button
                size="sm"
                icon={<IoShareSocial size={16} aria-hidden />}
                onClick={() => { if (readOnly) return; handleGenerateReferral(); }}
                disabled={readOnly}
                title={readOnlyTitle}
              >
                Referral
              </Button>
            )}

            {/* {isFromOfflinePage && (
              <Button size="sm" onClick={() => { if (readOnly) return; handleOfflineCourse(); }} disabled={readOnly} title={readOnlyTitle}>
                Offline Enrollment
              </Button>
            )} */}

            {selectedCourseDetails?.isDemoCourse === false && (
              <Button
                size="sm"
                icon={<LiaChalkboardTeacherSolid size={16} aria-hidden />}
                onClick={() => { if (readOnly) return; toggleModal(); }}
                disabled={readOnly}
                title={readOnlyTitle}
              >
                Extend Course
              </Button>
            )}

            {studentData?.studentType === "PAID" && (
              <Button
                size="sm"
                icon={<LiaSalesforce size={18} aria-hidden />}
                onClick={() => {
                  if (readOnly || loadingSalesForce) return;
                  handleSyncSalesForce();
                }}
                loading={loadingSalesForce}
                disabled={readOnly}
                title={readOnlyTitle}
              >
                {loadingSalesForce ? "Syncing ..." : "Sync Salesforce"}
              </Button>
            )}

            <a
              href={`http://betadashboard.artiumacademy.com/?studentId=${studentId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ds-btn ds-btn--secondary ds-btn--sm"
              onClick={(e) => {
                e.preventDefault();
                openDashboardWithAuth(
                  `http://betadashboard.artiumacademy.com/?studentId=${studentId}`
                );
              }}
            >
              <IoShareSocial size={16} aria-hidden />
              View Dashboard
            </a>
          </div>

          {studentData.status && (
            <div className="student-home__status">
              <StudentStatusBadge status={studentData.status} label={studentData.status} />
            </div>
          )}

          <div className="student-home__profile">
            <div className="student-home__identity">
              {studentData.profilePhoto ? (
                <Image src={studentData.profilePhoto} className="img-fluid student-home__photo" alt="user" />
              ) : (
                <div className="student-home__avatar" aria-hidden>
                  {studentData.firstName ? studentData.firstName.trim().charAt(0).toUpperCase() : "U"}
                </div>
              )}
              <h2 className="ds-card__title">
                {studentData.firstName} {studentData.lastName}
              </h2>
            </div>

            <div className="student-home__details">
              <DescriptionList items={detailItems} />

              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="policyToggle"
                  checked={policyEnabled}
                  onChange={handlePolicyToggle}
                  disabled={policyLoading || readOnly}
                />
                <label className="form-check-label ds-strong" htmlFor="policyToggle">
                  {policyLoading ? "Loading..." : policyEnabled ? "New Policy" : "Old Policy"}
                </label>
              </div>
              {/* Student active toggle (disabled):
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="studentActiveToggle"
                  checked={isStudentAccountActive}
                  onChange={handleStudentActiveToggle}
                  disabled={studentStatusLoading || readOnly}
                  title={readOnly ? "Disabled for Teacher Leaders" : undefined}
                />
                <label className="form-check-label ds-strong" htmlFor="studentActiveToggle">
                  {studentStatusLoading ? "Loading..." : isStudentAccountActive ? "Active" : "Deactivated"}
                </label>
              </div> */}
              {selectedCourseDetails?.courseEnrollmentId && (() => {
                const isToggleDisabled = is30MinsClassLoading || readOnly;

                return (
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="is30MinsClassToggle"
                      checked={is30MinsClass}
                      onChange={handleIs30MinsClassToggle}
                      disabled={isToggleDisabled}
                    />
                    <label className="form-check-label ds-strong" htmlFor="is30MinsClassToggle">
                      30 min class
                    </label>
                  </div>
                );
              })()}
            </div>

            <div className="student-home__settings">
              <Field
                label="Graded certificate"
                hint={certificate ? `Current certificate: ${certificate}` : undefined}
              >
                {(ctl) => (
                  <select
                    {...ctl}
                    value={selectedCertificate || ''}
                    onChange={handleCertificateChange}
                    className="ds-select"
                    disabled={readOnly}
                    title={readOnlyTitle}
                  >
                    <option value="" disabled>Select Certificate</option>
                    {certificateOptions.map((cert, index) => (
                      <option key={index} value={cert}>
                        {cert}
                      </option>
                    ))}
                  </select>
                )}
              </Field>

              <Field label="Free attempts">
                {(ctl) => (
                  <select
                    {...ctl}
                    value={attemptCount || ""}
                    onChange={handleFreeAttempt}
                    className="ds-select"
                    disabled={readOnly}
                    title={readOnlyTitle}
                  >
                    <option value="" disabled>Select Attempt Count</option>
                    <option value="2">2</option>
                    <option value="4">4</option>
                  </select>
                )}
              </Field>

              {studentData?.studentType === "PAID" && (
                <Field label="Membership" id="membershipTypeSelect">
                  {(ctl) => (
                    <select
                      {...ctl}
                      value={selectedMembership || ''}
                      onChange={handleMembershipSelect}
                      className="ds-select"
                      disabled={readOnly}
                      title={readOnlyTitle}
                    >
                      <option value="" disabled>Select Membership Type</option>
                      <option value="GOLD">Gold</option>
                      <option value="PLATINUM">Platinum</option>
                      <option value="SILVER">Silver</option>
                      <option value="N/A">None</option>
                    </select>
                  )}
                </Field>
              )}
            </div>
          </div>

          {/* Confirmation Modal */}
          <Dialog
            isOpen={showConfirmationModal}
            onClose={cancelMembershipChange}
            title="Confirm membership change"
            actions={
              <>
                <Button variant="secondary" onClick={cancelMembershipChange}>Cancel</Button>
                <Button variant="primary" loading={loading} onClick={confirmMembershipChange}>
                  {loading ? "Processing..." : "Confirm"}
                </Button>
              </>
            }
          >
            <p className="student-home__dialog-text">
              Are you sure you want to change the membership to {pendingMembershipChange.membershipType === "GOLD" ? "Gold" :
              pendingMembershipChange.membershipType === "PLATINUM" ? "Platinum" : "None"}?
            </p>
          </Dialog>

          <div className="student-home__form">
            <ProfileForm studentId={studentId} credentialId={credentialId} fetchProfile={fetchStudentProfile}   fetchCourses={fetchCourses}    studentProfileData={studentData}  />
          </div>
        </>
      ) : (
        <Loader label="Loading student details…" />
      )}

      <Dialog
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={shortUrl ? "Generated Referral Link" : "Login OTP"}
        actions={
          shortUrl ? undefined : (
            <Button
              variant="primary"
              icon={<FaCopy aria-hidden />}
              onClick={() => {
                navigator.clipboard.writeText(otp?.toString() || '');
                toast.success('OTP copied to clipboard!');
              }}
            >
              Copy OTP
            </Button>
          )
        }
      >
        {shortUrl ? (
          <div className="student-home__referral">
            <p className="student-home__dialog-text">Your referral link:</p>
            <a href={shortUrl} target="_blank" rel="noopener noreferrer" className="student-home__link">
              {shortUrl}
            </a>
          </div>
        ) : (
          <div className="student-home__otp" aria-label="One-time password">
            {otp?.toString().split("").map((digit, index) => (
              <span key={index} className="student-home__otp-digit">
                {digit}
              </span>
            ))}
          </div>
        )}
      </Dialog>

      <Dialog
        isOpen={modal}
        onClose={toggleModal}
        title="Extend course"
        subtitle={`Number of classes to extend: ${expiryCount || ''}`}
        actions={
          <>
            <Button variant="secondary" onClick={() => window.open(`https://prod-mb.artiumacademy.com/question/915-for-ops-class-expiry-extension-history?student_id=${studentId}`, '_blank')}>Check history</Button>
            {/* Submit Button (submits the form below via the form attribute) */}
            <Button type="submit" form="extendExpiryForm" variant="primary" onClick={handleSubmit} disabled={ !modificationReason || !expiryDate|| isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </Button>
          </>
        }
      >
        <form id="extendExpiryForm" className="student-home__dialog-form" onSubmit={handleSubmit}>
          <Field label="Modification reason" id="modificationReason">
            {(ctl) =>
              isOfflineBatchCourse ? (
                <Select
                  {...ctl}
                  value={modificationReason}
                  onChange={(e) => {
                    setModificationReason(e.target.value);
                    setExpiryDate(null);
                  }}
                  required
                  options={[
                    { value: "", label: "Select a reason" },
                    ...OFFLINE_EXPIRY_REASON_OPTIONS.map((option) => ({ value: option.value, label: option.label })),
                  ]}
                />
              ) : (
                <TextInput
                  {...ctl}
                  type="text"
                  value={modificationReason}
                  onChange={(e) => setModificationReason(e.target.value)}
                  placeholder="Enter reason for modification"
                  required
                />
              )
            }
          </Field>
          {isOfflineBatchCourse && selectedOfflineReason ? (
            <Callout
              tone="neutral"
              title={offlineExpiryMaxDate ? `Max allowed date: ${offlineExpiryMaxDate.toISOString().slice(0, 10)}` : undefined}
            >
              {selectedOfflineReason.description}
            </Callout>
          ) : null}

          <Field
            label="Expiry date"
            id="expiryDate"
            hint={
              isOfflineBatchCourse && !modificationReason
                ? "Please select a modification reason before choosing the expiry date."
                : undefined
            }
          >
            {(ctl) => (
              <DatePicker
                placeholderText={
                  isOfflineBatchCourse && !modificationReason
                    ? "Select a reason first"
                    : "Select the date"
                }
                id={ctl.id}
                ariaDescribedBy={ctl['aria-describedby']}
                selected={expiryDate}
                onChange={(date) => setExpiryDate(date || new Date())}
                dateFormat="yyyy-MM-dd"
                className="ds-input"
                wrapperClassName="student-home__datepicker"
                maxDate={offlineExpiryMaxDate}
                disabled={isOfflineBatchCourse && !modificationReason}
              />
            )}
          </Field>
        </form>
      </Dialog>

      <Dialog
        isOpen={showResetModal}
        onClose={() => setShowResetModal(false)}
        title="Confirm reset OTP"
        actions={
          <>
            <Button variant="secondary" onClick={() => setShowResetModal(false)}>Cancel</Button>
            <Button
              variant="primary"
              onClick={async () => {
                setResetLoading(true);
                try {
                  await resetotp(studentData?.mobileNumber);
                  toast.success("OTP reset successfully!");
                  setShowResetModal(false);
                } catch (e) {
                  toast.error("Failed to reset OTP");
                } finally {
                  setResetLoading(false);
                }
              }}
              loading={resetLoading}
            >
              {resetLoading ? "Resetting..." : "OK"}
            </Button>
          </>
        }
      >
        <p className="student-home__dialog-text">
          Are you sure you want to reset the OTP for <span className="ds-strong">{studentData?.mobileNumber}</span>?
        </p>
      </Dialog>

      {/* Offline Course Enrollment Modal */}
      <Dialog
        isOpen={showOfflineCourseModal}
        onClose={() => setShowOfflineCourseModal(false)}
        title="Enroll in offline course"
        actions={
          <>
            <Button
              variant="secondary"
              onClick={() => {
                setShowOfflineCourseModal(false);
                setSelectedCenter(null);
                setSelectedOfflineCourse(null);
                setSelectedOfflineTeacher(null);
                setOfflineTeachers([]);
                setOfflineMonthsPurchased("");
                setOfflineStartDate(null);
                setOfflineSelectedLevel("");
              }}
              disabled={offlineEnrollmentLoading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleOfflineCourseSubmit}
              disabled={!selectedCenter || !selectedOfflineCourse || !selectedOfflineTeacher || offlineEnrollmentLoading}
              loading={offlineEnrollmentLoading}
            >
              {offlineEnrollmentLoading ? 'Enrolling...' : 'Enroll'}
            </Button>
          </>
        }
      >
        {/* Center Selection Dropdown */}
        <Field label="Center" id="centerSelect">
          {(ctl) => (
            <Select
              {...ctl}
              value={selectedCenter ? selectedCenter.centerId : ''}
              onChange={(e) => {
                const center = offlineCentres.find((c: any) => c.centerId === parseInt(e.target.value));
                setSelectedCenter(center || null);
                setSelectedOfflineCourse(null); // Reset course when center changes
              }}
              options={[
                { value: "", label: "-- Select a Center --" },
                ...offlineCentres.map((center: any) => ({
                  value: String(center.centerId),
                  label: `${center.centreName} - ${center.name}`,
                })),
              ]}
            />
          )}
        </Field>

        {/* Courses Selection Dropdown */}
        <Field label="Course" id="courseSelect" hint={!selectedCenter ? "Please select a center first" : undefined}>
          {(ctl) => (
            <Select
              {...ctl}
              value={selectedOfflineCourse ? selectedOfflineCourse.v2Id : ''}
              onChange={(e) => {
                const course = getOfflineCourses().find((c: any) => c.v2Id === e.target.value);
                setSelectedOfflineCourse(course || null);
                setSelectedOfflineTeacher(null);
                setOfflineTeachers([]);
                setOfflineSelectedLevel(""); // Reset level when course changes

                // Fetch teachers when course and center are selected
                if (course && selectedCenter) {
                  fetchOfflineTeachers(course.v2Id);
                }
              }}
              disabled={!selectedCenter}
              options={[
                { value: "", label: "-- Select a Course --" },
                ...getOfflineCourses().map((course: any) => ({ value: course.v2Id, label: course.name })),
              ]}
            />
          )}
        </Field>

        {/* Teacher Selection Dropdown */}
        <Field
          label="Teacher"
          id="teacherSelect"
          hint={loadingTeachers ? "Loading teachers…" : !selectedOfflineCourse ? "Please select a course first" : undefined}
        >
          {(ctl) => (
            <Select
              {...ctl}
              value={selectedOfflineTeacher ? selectedOfflineTeacher.teacherId : ''}
              onChange={(e) => {
                const teacher = offlineTeachers.find((t: any) => t.teacherId === e.target.value);
                setSelectedOfflineTeacher(teacher || null);
              }}
              disabled={!selectedOfflineCourse || loadingTeachers}
              options={[
                { value: "", label: "-- Select a Teacher --" },
                ...offlineTeachers.map((teacher: any) => ({ value: teacher.teacherId, label: teacher.teacherName })),
              ]}
            />
          )}
        </Field>

        {/* Level Selection */}
        <Field label="Level" id="offlineLevel" hint={!selectedOfflineCourse ? "Please select a course first" : undefined}>
          {(ctl) => (
            <Select
              {...ctl}
              value={offlineSelectedLevel}
              onChange={(e) => setOfflineSelectedLevel(e.target.value)}
              disabled={!selectedOfflineCourse}
              options={[
                { value: "", label: "-- Select Level --" },
                ...(selectedOfflineCourse && selectedOfflineCourse.tags && Array.isArray(selectedOfflineCourse.tags)
                  ? selectedOfflineCourse.tags.map((tag: any) => ({ value: tag.name, label: tag.name }))
                  : [{ value: "PREPARATORY", label: "Preparatory" }]),
              ]}
            />
          )}
        </Field>
        <Field label="Months purchased" id="offlineMonthsPurchased">
          {(ctl) => (
            <TextInput
              {...ctl}
              type="number"
              numeric
              value={offlineMonthsPurchased}
              onChange={(e) => setOfflineMonthsPurchased(e.target.value)}
              placeholder="Enter number of months"
              min="1"
            />
          )}
        </Field>
        <Field label="Start date" id="offlineStartDate">
          {(ctl) => (
            <DatePicker
              placeholderText="Select start date"
              id={ctl.id}
              selected={offlineStartDate}
              onChange={(date) => setOfflineStartDate(date)}
              dateFormat="yyyy-MM-dd"
              className="ds-input"
              wrapperClassName="student-home__datepicker"
            />
          )}
        </Field>
      </Dialog>

      <PolicyChangeModal />

      {/* 30 Mins Class Confirmation Modal */}
      <Dialog
        isOpen={show30MinsClassModal}
        onClose={cancel30MinsClassChange}
        title="Confirm 30 min class change"
        actions={
          <>
            <Button
              variant="secondary"
              onClick={cancel30MinsClassChange}
              disabled={is30MinsClassLoading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={confirm30MinsClassChange}
              disabled={!thirtyMinsChangeReason.trim()}
              loading={is30MinsClassLoading}
            >
              {is30MinsClassLoading ? "Processing..." : "Confirm"}
            </Button>
          </>
        }
      >
        <p className="student-home__dialog-text">
          Are you sure you want to {pending30MinsClassChange ? "enable" : "disable"} 30 min class?
        </p>
        <Field label="Reason" id="thirtyMinsChangeReason" required>
          {(ctl) => (
            <TextArea
              {...ctl}
              rows={3}
              value={thirtyMinsChangeReason}
              onChange={(e) => setThirtyMinsChangeReason(e.target.value)}
              placeholder="Enter reason for changing 30 min class"
              disabled={is30MinsClassLoading}
            />
          )}
        </Field>
      </Dialog>

      <Dialog
        isOpen={showDeactivateModal}
        onClose={() => { if (!studentStatusLoading) setShowDeactivateModal(false); }}
        title="Deactivate student"
        actions={
          <>
            <Button
              variant="secondary"
              onClick={() => setShowDeactivateModal(false)}
              disabled={studentStatusLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => void confirmDeactivateStudent()}
              loading={studentStatusLoading}
            >
              {studentStatusLoading ? "Deactivating..." : "Confirm Deactivate"}
            </Button>
          </>
        }
      >
        <p className="student-home__dialog-text">Are you sure you want to deactivate this student?</p>
        <Callout tone="danger">
          The student will get deactivated and you will be redirected to the student list.
        </Callout>
      </Dialog>
    </div>
  );
};

export default Home;
